"use strict";

exports.__esModule = true;
exports.MetricFieldSelector = MetricFieldSelector;
var _react = _interopRequireDefault(require("react"));
var _Selector = require("../../Core/Selector");
var _metricFieldDefinitions = require("../../../Catalogs/Metrics/metricFieldDefinitions");
var _Core = require("../../Core");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function getKey(input) {
  return input.name;
}
function renderItemText(input) {
  return input.label;
}
function itemPredicate(query, item) {
  var q = query.toLowerCase();
  return item.name.toLowerCase().indexOf(q) !== -1 || item.label.toLowerCase().indexOf(q) !== -1 || item.description.toLowerCase().indexOf(q) !== -1;
}

/**
 * Allows a user to select metric field(s) from a list.
 */
function MetricFieldSelector(props) {
  return /*#__PURE__*/_react["default"].createElement(_Core.Translator, null, function (_ref) {
    var translate = _ref.translate;
    return /*#__PURE__*/_react["default"].createElement(_Selector.Selector, _extends({
      placeholder: props.multiple ? translate("MetricFieldSelector.placeholder.multiple", "Select Fields") : translate("MetricFieldSelector.placeholder.single", "Select Field"),
      getKey: getKey,
      renderItemText: renderItemText,
      itemPredicate: itemPredicate,
      items: _metricFieldDefinitions.metricFieldDefinitions
    }, props));
  });
}